import { yupResolver } from '@hookform/resolvers/yup';
import { cnpj } from 'cpf-cnpj-validator';
import { useSnackbar } from 'notistack';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router';
import { paths } from 'src/routes/paths';
import { useShopkeepersStore } from 'src/store/users/shopkeepers.store';
import * as Yup from 'yup';

export default function useShopkeepersDetails() {
  const { id } = useParams();
  const { pathname } = useLocation();
  const isEdit = pathname.includes('edit');
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const STATUS_OPTIONS = [
    { label: 'Ativo', value: 'active' },
    { label: 'Inativo', value: 'inactive' },
  ];

  const STATUS_LABEL = ['Ativo', 'Inativo'];

  const {
    getShopkeeperDetails,
    updateShopkeeper,
    registerShopkeeper,
    resetShopkeeperToEdit,
    isLoadingShopkeeperDetails,
    shopkeeperDetails,
  } = useShopkeepersStore();
  
  const defaultValues = useMemo(
    () => ({
      name: shopkeeperDetails?.shopkeeperInfo.name || '',
      code: shopkeeperDetails?.shopkeeperInfo.code || '',
      status: shopkeeperDetails?.status || 'active',
      cnpj: shopkeeperDetails?.shopkeeperInfo.cnpj || '',
    }),
    [shopkeeperDetails]
  );

  const ShopkeeperSchema = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório!'),
    code: Yup.string().required('Código é obrigatório!'),
    cnpj: Yup.string()
      .required('CNPJ é obrigatório!')
      .test('cnpj-validation', 'CNPJ inválido. Por favor, insira um CNPJ válido.', (v) => cnpj.isValid(v)),
    status: Yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(ShopkeeperSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    if (id) {
      getShopkeeperDetails(id);
    } else {
      resetShopkeeperToEdit()
    }
  }, [id]);

  const onSubmit = handleSubmit(async (data: any) => {
    try {
      if (isEdit && id) {
        data.id = id;
      }
      if (isEdit) {
        await updateShopkeeper(data);
        enqueueSnackbar('Lojista Editado com Sucesso!');
      } else {
        await registerShopkeeper(data);
        enqueueSnackbar('Lojista Criado com Sucesso!');
      }
      reset();
      navigate(paths.dashboard.shopkeepersList);
    } catch (error) {
      console.error(error);
    }
  });

  useEffect(() => {
    if (defaultValues && shopkeeperDetails) {
      reset(defaultValues);
    } else {
      reset(defaultValues);
    }
  }, [shopkeeperDetails, reset, defaultValues]);

  return {
    isEdit,
    isSubmitting,
    methods,
    STATUS_OPTIONS,
    STATUS_LABEL,
    isLoadingShopkeeperDetails,
    onSubmit,
    reset,
    watch,
    setValue,
  };
}
